var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-view"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":_vm.isLeft,"fixed":""},on:{"click-left":function($event){return _vm.$router.go(-1)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }